var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0267 1.87988C7.61333 1.87988 4.02666 5.46655 4.02666 9.87988V13.7332C4.02666 14.5465 3.67999 15.7865 3.26666 16.4799L1.73333 19.0265C0.786662 20.5999 1.44 22.3465 3.17333 22.9332C8.91999 24.8532 15.12 24.8532 20.8667 22.9332C22.48 22.3999 23.1867 20.4932 22.3067 19.0265L20.7733 16.4799C20.3733 15.7865 20.0267 14.5465 20.0267 13.7332V9.87988C20.0267 5.47988 16.4267 1.87988 12.0267 1.87988Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.7dda085a1ff0546ba2ae007e348c7d1a.svg";
export { ForwardRef as ReactComponent };